import React, {KeyboardEvent, ReactElement} from 'react';
import {Formik} from 'formik';
import {MagnifyingGlass} from '../../Icons';
import KeyCodes from '../../../../keyCodes';

import './SearchBar.scss';

interface Props {
  name: string;
  placeholder?: string;
  onSubmit: (value: string) => void;
  isDisabled?: boolean;
}

function SearchBar({name, placeholder, onSubmit, isDisabled = false}: Props): ReactElement {
  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      initialValues={{[name]: ''}}
      onSubmit={(values) => {
        onSubmit(values[name]);
      }}
    >
      {({values, handleSubmit, handleChange}) => (
        <div className="searchBar">
          <input
            id={name}
            name={name}
            onChange={handleChange}
            onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
              if (event.keyCode === KeyCodes.ENTER) {
                handleSubmit();
              }
            }}
            placeholder={placeholder}
            type="search"
            value={values[name]}
            disabled={isDisabled}
            data-testid="field.searchBar.input"
          />
          <button
            className="searchBar__submitButton"
            onClick={() => handleSubmit()}
            type="button"
            tabIndex={0}
            disabled={isDisabled}
            data-testid="field.searchBar.button"
          >
            <MagnifyingGlass />
          </button>
        </div>
      )}
    </Formik>
  );
}

export default SearchBar;
